var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _circle2, _path8, _path9, _path10, _path11, _path12, _circle3, _path13, _path14, _path15, _circle4, _rect, _path16, _rect2, _path17, _rect3, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceFinanceTracking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 139,
    viewBox: "0 0 272 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 98C51.6731 98 66 83.6731 66 66C66 48.3269 51.6731 34 34 34C16.3269 34 2 48.3269 2 66C2 83.6731 16.3269 98 34 98Z",
    fill: "#55CF7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4609 63.5391L16.7686 83.2314",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7692,
    cy: 14.7692,
    r: 14.7692,
    transform: "matrix(-1 0 0 1 51.2305 48.7695)",
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5376 59.8463V59.8463C39.5376 58.4868 38.4356 57.3848 37.0761 57.3848H35.8453C34.4859 57.3848 33.3838 58.4868 33.3838 59.8463V60.2988C33.3838 61.1634 33.8374 61.9647 34.5789 62.4095L38.3425 64.6677C39.084 65.1126 39.5376 65.9138 39.5376 66.7785V67.2309C39.5376 68.5904 38.4356 69.6925 37.0761 69.6925H35.8453C34.4859 69.6925 33.3838 68.5904 33.3838 67.2309V67.2309",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4609 57.3851L36.4609 56.1543",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4609 70.9241L36.4609 69.6934",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130 98C112.327 98 98 83.6731 98 66C98 48.3269 112.327 34 130 34C147.673 34 162 48.3269 162 66C162 83.6731 147.673 98 130 98Z",
    fill: "#55CF7E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.462 63.5391L112.77 83.2314",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7692,
    cy: 14.7692,
    r: 14.7692,
    transform: "matrix(-1 0 0 1 147.231 48.7695)",
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M135.539 59.8463V59.8463C135.539 58.4868 134.437 57.3848 133.077 57.3848H131.846C130.487 57.3848 129.385 58.4868 129.385 59.8463V60.2988C129.385 61.1634 129.838 61.9647 130.58 62.4095L134.344 64.6677C135.085 65.1126 135.539 65.9138 135.539 66.7785V67.2309C135.539 68.5904 134.437 69.6925 133.077 69.6925H131.846C130.487 69.6925 129.385 68.5904 129.385 67.2309V67.2309",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.462 57.3851L132.462 56.1543",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.462 70.9241L132.462 69.6934",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226 106C203.909 106 186 88.0914 186 66C186 43.9086 203.909 26 226 26C248.091 26 266 43.9086 266 66C266 88.0914 248.091 106 226 106Z",
    fill: "#55CF7E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M229.077 62.9248L204.462 87.5402",
    stroke: "#24284E",
    strokeWidth: 6.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4615,
    cy: 18.4615,
    r: 18.4615,
    transform: "matrix(-1 0 0 1 247.539 44.4629)",
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 4.61539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M232.924 58.3084V58.3084C232.924 56.609 231.546 55.2314 229.847 55.2314H228.308C226.609 55.2314 225.231 56.609 225.231 58.3084V58.8739C225.231 59.9547 225.799 60.9563 226.725 61.5124L231.43 64.3351C232.357 64.8912 232.924 65.8928 232.924 66.9736V67.5391C232.924 69.2385 231.546 70.6161 229.847 70.6161H228.308C226.609 70.6161 225.231 69.2385 225.231 67.5391V67.5391",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M229.078 55.2318L229.078 53.6934",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M229.078 72.1556L229.078 70.6172",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 24.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 96L158.5 100L165.5 92",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 96L62.5 100L69.5 92",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 96,
    r: 2,
    fill: "#24284E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 96,
    r: 2,
    fill: "#24284E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 96,
    r: 2,
    fill: "#24284E"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 2,
    r: 2,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 120,
    r: 2,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 119.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 137.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.5,
    cy: 134.5,
    r: 1.5,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177 19L186 26.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263 4.5L256 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M202.5 115.5L195.5 126",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceFinanceTracking);
export default __webpack_public_path__ + "static/media/persistence-finance-tracking.028d2aba5f03e5b600ccd0c4c460a7da.svg";
export { ForwardRef as ReactComponent };